<template>
	<router-link :to="{ name: 'Puzzle', params: { id: id } }">
		<div class="puzzle-piece">
			<div class="puzzle-btn mx-auto">
				<div class="h-100 d-flex museum-button-bg-img " :style="style">
					<div class="h-100 w-100 museum-galerij-button-text-bg">
						<div class="h-100 d-flex">
							<h1 class="m-auto text-center">{{ title }}</h1>
						</div>
					</div>
				</div>
			</div>
		</div>
	</router-link>
</template>

<script>
export default {
	name: "PuzzleOverviewItem",
	props: {
		title: String,
		image: String,
		id: Number,
	},
	computed: {
		style() {
			return `background-image: url('${this.image}')`;
		},
	},
};
</script>

<style scoped>

.puzzle-piece:nth-child(even) {
	mask-image: url("~@/assets/img/puzzle_piece.svg");
	mask-repeat: no-repeat;
	mask-size: contain;
	mask-position: center center;
	position: relative;
}

.puzzle-piece:nth-child(odd) {
	mask-image: url("~@/assets/img/puzzle_piece.svg");
	mask-repeat: no-repeat;
	mask-size: contain;
	mask-position: center center;
	position: relative;
}

/* .puzzle-piece::after {
	position: absolute;
	content: '';
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background-image: url("~@/assets/img/Geel_puzzle_piece.svg");
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center center;
	z-index: 1;
} */

.puzzle-btn {
	position: relative;
	height: 500px;
	width: 500px;
}

.museum-galerij-button-text-bg h1 {
    font-size: 46px;
}
</style>

